import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";

function YesNoSelect({ title = "", xs = 12, md = 4, handler, initialValue = null }) {
  const [value, setValue] = useState(null);

  const options = [
    {
      value: 1,
      label: "ΝΑΙ",
    },
    {
      value: 0,
      label: "ΟΧΙ",
    },
  ];

  const handleChange = (e) => {
    setValue(e);
    handler(e.value);
  };
  const selectOptionById = () => {
    let selectedRole = options.find((el) => el.value == initialValue);
    if (!selectedRole) return;
    setValue(selectedRole);
  };

  useEffect(() => {
    selectOptionById();
  }, [initialValue]);

  return (
    <Grid item xs={xs} md={md}>
      <SoftBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
        <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
          <SoftTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
          >
            {title}
          </SoftTypography>
        </SoftBox>
        <SoftSelect
          placeholder={title}
          options={options}
          size="large"
          onChange={handleChange}
          value={value}
        />
      </SoftBox>
    </Grid>
  );
}

export default YesNoSelect;
